<template>
    <span
        class="text-danger float-left mr-1">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Cronograma de Desembolso do SEBRAE"
            @click.stop="confirmarExcluir(cronogramaDesembolsoSebrae.cronogramaDesembolsoSebraeId)"
        ></i>
    </span>
</template>

<script>

export default {
    props: {
        cronogramaDesembolsoSebrae:{
            type: Object
        },
        dataServicos: {
            type: Object
        },
        pleito: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir(id) {
            this.$swal({
                title: 'Excluir',
                html:
                    'Deseja Excluir a parcela <strong>' +
                    this.cronogramaDesembolsoSebrae.parcela +
                    '</strong> do mês <strong>' + this.$moment(this.cronogramaDesembolsoSebrae.mes).format('MM/YYYY') + '</strong> do cronograma de desembolso?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id) {
            this.$store.dispatch('addRequest')
            this.dataServicos.excluirCronogramaDesembolsoSebrae(this.pleito.pleitoId, id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Cronograma excluído com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarLista')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    },
}
</script>
